<template>
  <div class="booking">
    <tabbar></tabbar>
    <div class="alone"
         v-if="ispersonal">
      <div class="column">
        <div class="wrapper">
          <span class="title">预约日期</span>
          <span class="shade1"></span>
          <calendar :events="calendar1.events"
                    :lunar="calendar1.lunar"
                    :value="calendar1.value"
                    :begin="calendar1.begin"
                    :end="calendar1.end"
                    :weeks="calendar1.weeks"
                    :months="calendar1.months"
                    @select="select"></calendar>
          <span class="shade2"></span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/time.png"
                   width="100%"
                   height="100%" />
            </div>
            <p>预约时间</p>
          </span>
          <!-- <span class="info_text">{{ bookingTime.bookingAllday }}</span> -->
          <span class="info_text e6824d"
                @click="open1">{{ chooseTime }}</span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/piao.png"
                   width="100%"
                   height="100%" />
            </div>
            <p>电子票价</p>
          </span>
          <span class="info_text">{{ fares }}</span>
        </div>
      </div>
      <personalinfo ref="info"
                    :id="ispersonal"
                    :ticketdate="selectedDate"
                    :bookingdata="chooseTime"
                    :nowTicketLeft="nowTicketLeft"
                    :groupBookingAvailable="true"></personalinfo>
    </div>
    <div class="group"
         v-else>
      <div class="column">
        <div class="wrapper">
          <span class="title">预约日期</span>
          <span class="shade1"></span>
          <calendar :range="calendar1.range"
                    :events="calendar1.events"
                    :lunar="calendar1.lunar"
                    :value="calendar1.value"
                    :begin="calendar1.begin"
                    :end="calendar1.end"
                    :weeks="calendar1.weeks"
                    :months="calendar1.months"
                    :disabled="calendar1.disabled"
                    @select="select"></calendar>
          <span class="shade2"></span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/time.png"
                   width="100%"
                   height="100%" />
            </div>
            <p>预约时间</p>
          </span>
          <span class="info_text e6824d"
                @click="open1">{{ chooseTime }}</span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/piao.png"
                   width="100%"
                   height="100%" />
            </div>
            <p>讲解</p>
          </span>
          <span class="info_text e6824d"
                @click="open2">
            {{
            chooseCommentator
            }}
          </span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/piao.png"
                   width="100%"
                   height="100%" />
            </div>
            <p>电子票价</p>
          </span>
          <span class="info_text">{{ fares }}</span>
        </div>
      </div>
      <div class="column">
        <div class="wrapper">
          <span class="title">预约团体信息</span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/time.png"
                   width="100%"
                   height="100%" />
            </div>
            <p>团体概况</p>
          </span>
          <span class="info_text e6824d"
                @click="open3">{{ chooseGroup }}</span>
          <el-form :model="peopleNumber"
                   ref="peopleNumber"
                   label-width="2rem"
                   class="demo-ruleForm visit-form">
            <div class="info_icon visit-icon">
              <img src="@/assets/icons/idcard.png"
                   width="100%"
                   height="100%" />
            </div>
            <el-form-item label="参观人数"
                          prop="number"
                          :rules="[
                { required: true, message: '参观人数不能为空' },
                { type: 'number', message: '参观人数必须为数字值' }
              ]">
              <el-input type="number"
                        v-model.number="peopleNumber.number"
                        autocomplete="off"
                        placeholder="请输入人数"
                        maxlength="5"></el-input>
            </el-form-item>
          </el-form>
          <el-form :model="peopleNumber"
                   ref="peopleNumber"
                   label-width="2rem"
                   class="demo-ruleForm visit-form child-form">
            <div class="info_icon visit-icon">
              <img src="@/assets/icons/children.png"
                   width="100%"
                   height="100%" />
            </div>
            <el-form-item label="携带儿童"
                          prop="children">
              <el-radio-group v-model="peopleNumber.children"
                              size="medium">
                <el-radio v-model="radio1"
                          label="1"
                          border>是</el-radio>
                <el-radio v-model="radio1"
                          label="2"
                          border>否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="age"
                          :rules="[
                { required: true, message: '参观人数不能为空' },
                { type: 'number', message: '参观人数必须为数字值' }
              ]"
                          class="age"
                          v-show="peopleNumber.children === '1'">
              <el-input type="number"
                        v-model.number="peopleNumber.age"
                        autocomplete="off"
                        placeholder="请输入儿童数量"
                        maxlength="5"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <mt-popup v-model="commentator"
                position="bottom"
                popup-transition="popup-fade">
        <div class="popup">
          <span class="popup-title">讲解</span>
          <el-radio-group v-model="radio2"
                          size="medium">
            <el-radio label="1"
                      border>是</el-radio>
            <el-radio label="2"
                      border>否</el-radio>
          </el-radio-group>
          <el-button @click="return2">确定</el-button>
        </div>
      </mt-popup>
      <mt-popup v-model="group"
                position="bottom"
                popup-transition="popup-fade">
        <div class="popup">
          <span class="popup-title">团队概况</span>
          <el-radio-group v-model="radio3"
                          size="medium">
            <el-radio label="1"
                      border
                      v-show="unitProperty[0]">
              {{
              unitProperty[0]
              }}
            </el-radio>
            <el-radio label="2"
                      border
                      v-show="unitProperty[1]">
              {{
              unitProperty[1]
              }}
            </el-radio>
            <el-radio label="3"
                      border
                      v-show="unitProperty[2]">
              {{
              unitProperty[2]
              }}
            </el-radio>
            <el-radio label="4"
                      border
                      v-show="unitProperty[3]">
              {{
              unitProperty[3]
              }}
            </el-radio>
          </el-radio-group>
          <el-button @click="return3">确定</el-button>
        </div>
      </mt-popup>
      <personalinfo ref="info"
                    :id="ispersonal"
                    :bookingdata="chooseTime"
                    :commentator1="chooseCommentator"
                    :unitproperty="chooseGroup"
                    :peoplenumber="peopleNumber.number"
                    :children="peopleNumber.children === '2' ? false : true"
                    :age="peopleNumber.age"
                    :groupBookingAvailable="
          peopleNumber.number > nowTicketLeft ? false : true
        "
                    :ticketdate="selectedDate"></personalinfo>
    </div>
    <mt-popup v-model="time"
              position="bottom"
              popup-transition="popup-fade">
      <div class="popup">
        <span class="popup-title">预约时间</span>
        <el-radio-group v-model="radio1"
                        size="medium">
          <el-radio label="1"
                    border>
            {{
              bookingTime.bookingForenoon
              }}
          </el-radio>
          <el-radio label="2"
                    border
                    v-show="bookingTime.bookingNoon !== 'undefined~undefined'">{{ bookingTime.bookingNoon }}</el-radio>
          <el-radio label="3"
                    border
                    v-show="bookingTime.bookingAfternoon !== 'undefined~undefined'">{{ bookingTime.bookingAfternoon }}</el-radio>
          <el-radio label="4"
                    border
                    v-show="bookingTime.bookingNight !== 'undefined~undefined'">{{ bookingTime.bookingNight }}</el-radio>
        </el-radio-group>
        <el-button @click="return1">确定</el-button>
      </div>
    </mt-popup>
  </div>
</template>
<script>
import calendar from "@/components/calendar/calendar.vue";
import personalinfo from "@/components/personalInfo/personalinfo.vue";
import tabbar from "@/components/tabBar/tabBar";

// let selectDate = null
// selectDate = calendar1.select()

export default {
  name: "bookingInfo",
  components: {
    calendar,
    personalinfo,
    tabbar
  },
  data () {
    return {
      calendar1: {
        range: false,
        value: [],
        disabled: ["2019", "8", "3"],
        // lunar:true, //显示农历
        weeks: ["日", "一", "二", "三", "四", "五", "六"],
        months: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ],
        events: {},
        begin: [], //可选开始日期
        end: [] //可选结束日期
      },
      initEvents: {},
      ispersonal: this.$route.query.id,
      peopleNumber: {
        number: "",
        children: "2",
        age: ""
      },
      time: false,
      group: false,
      commentator: false,
      chooseTime: "选择时间",
      chooseGroup: "选择属性",
      chooseCommentator: "选择讲解需求",
      radio1: "1",
      radio2: "2",
      radio3: "1",
      bookingTime: {
        bookingForenoon: "", //上午
        bookingNoon: "", //正午
        bookingAfternoon: "", //下午
        bookingNight: "", //晚上
        bookingAllday: ""
      },
      fares: "",
      unitProperty: "",
      reservation: "",
      selectedDate: "",
      bookingForenoonList: {}, //上午列表
      bookingNoonList: {}, //正午列表
      bookingAfternoonList: {}, //下午列表
      bookingNightList: {}, //晚上列表
      bookingAlldayList: {}, //全天列表
      leftTicketForenoonList: {}, //上午余票列表
      leftTicketNoonList: {}, //正午余票列表
      leftTicketAfternoonList: {}, //下午余票列表
      leftTicketNightList: {}, //晚上余票列表
      leftTicketAlldayList: {}, //全天余票列表
      ticketsLeft: {
        bookingForenoon: "", //上午
        bookingNoon: "", //正午
        bookingAfternoon: "", //下午
        bookingNight: "", //晚上
        bookingAllday: ""
      }, //所选时间段余票
      nowTicketLeft: 0 //当前余票
    };
  },
  methods: {
    open1 () {
      this.time = true;
      this.chooseTimeQuantum();
    },
    return1 () {
      this.time = false;
      switch (this.radio1) {
        case "1":
          this.chooseTime = this.bookingTime.bookingForenoon;
          break;
        case "2":
          this.chooseTime = this.bookingTime.bookingNoon;
          break;
        case "3":
          this.chooseTime = this.bookingTime.bookingAfternoon;
          break;
        case "4":
          this.chooseTime = this.bookingTime.bookingNight;
          break;
      }
    },
    open2 () {
      this.commentator = true;
    },
    return2 () {
      this.commentator = false;
      switch (this.radio2) {
        case "1":
          this.chooseCommentator = "是";
          break;
        case "2":
          this.chooseCommentator = "否";
          break;
      }
    },
    open3 () {
      this.group = true;
    },
    return3 () {
      this.group = false;
      switch (this.radio3) {
        case "1":
          this.chooseGroup = this.unitProperty[0];
          break;
        case "2":
          this.chooseGroup = this.unitProperty[1];
          break;
        case "3":
          this.chooseGroup = this.unitProperty[2];
          break;
        case "4":
          this.chooseGroup = this.unitProperty[3];
          break;
      }
    },
    boolean () {
      if (this.ispersonal === "false" || this.ispersonal === false) {
        console.log(1);
        this.ispersonal = false;
      } else if (this.ispersonal === "true" || this.ispersonal === true) {
        this.ispersonal = true;
      }
    },
    //  获取票务信息
    getTicketInfo () {
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
          "/api/order/web/ticket/one-museum?museumCode=" +
          this.$store.state.museumCode,
          {}
        )
        .then(response => {
          var result = response.data;
          var end = result.data[result.data.length - 1];
          // console.log(result.data[0].ticketDate);
          // console.log(end.ticketDate.split("-"));
          this.calendar1.begin = result.data[0].ticketDate.split(",");
          this.calendar1.end = end.ticketDate.split(",");
          // console.log(this.calendar1.begin);
          //展示每日票数
          for (var item of result.data) {
            let key = item.ticketDate;
            if (item.reservation === false) {
              item.ticketsLeft = "闭 馆";
              this.$set(this.calendar1.events, [key], item.ticketsLeft);
              this.$set(this.initEvents, [key], item.ticketsLeft);
            } else {
              this.$set(
                this.calendar1.events,
                [key],
                "余 票");
              this.$set(
                this.initEvents,
                [key],
                // "余票<br>" + item.ticketsLeft
                "余 票"
              );
            }
          }
          //获取每日开馆时间段
          for (var item1 of result.data) {
            let key = item1.ticketDate;

            // 对应时间段
            this.$set(
              this.bookingForenoonList,
              [key],
              item1.bookingStartTime1 + "~" + item1.bookingEndTime1
            );
            this.$set(
              this.bookingNoonList,
              [key],
              item1.bookingStartTime2 + "~" + item1.bookingEndTime2
            );
            this.$set(
              this.bookingAfternoonList,
              [key],
              item1.bookingStartTime3 + "~" + item1.bookingEndTime3
            );
            this.$set(
              this.bookingNightList,
              [key],
              item1.bookingStartTime4 + "~" + item1.bookingEndTime4
            );

            // 对应票数
            this.$set(
              this.leftTicketForenoonList,
              [key],
              "余 票" + (item1.bookingTime1Count - item1.time1BookedCount)
            );
            this.$set(
              this.leftTicketNoonList,
              [key],
              "余 票" + (item.bookingTime2Count - item1.time2BookedCount)
            );
            this.$set(
              this.leftTicketAfternoonList,
              [key],
              "余 票" + (item1.bookingTime3Count - item1.time3BookedCount)
            );
            this.$set(
              this.leftTicketNightList,
              [key],
              "余 票" + (item1.bookingTime4Count - item1.time4BookedCount)
            );
            this.getTimeQuantum();
            this.getTicketLeft();
            //闭馆禁止点击
            this.$nextTick(() => {
              let a = document.getElementsByClassName("text").length;
              let b = document.getElementsByClassName("text");
              console.log(a);
              let i;
              for (i = 0; i < a; i++) {
                // console.log(b[i].parentNode)
                if (b[i].innerText === "闭 馆") {
                  // console.log(b[i].parentNode)
                  b[i].parentNode.style.pointerEvents = "none";
                }
              }
            });
          }
        });
    },
    //获取场馆信息
    getmuseumInfo () {
      console.log(this.$store.state.museumCode)
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
          "/api/order/web/ticket/detail?museumCode=" +
          this.$store.state.museumCode,
          {}
        )
        .then(response => {
          var result = response.data;
          // this.bookingForenoon =
          //   result.data.bookingStartTime1 + "~" + result.data.bookingEndTime1;
          // this.bookingAfternoon =
          //   result.data.bookingStartTime2 + "~" + result.data.bookingEndTime2;
          // this.bookingAllday =
          //   result.data.bookingStartTime1 + "~" + result.data.bookingEndTime2;
          this.fares = result.data.fares;
          this.unitProperty = result.data.unitProperty.split(",");
          console.log(result);
        });
    },
    // 弹出错误信息时显示输入框
    inputShow () {
      let a = document.getElementsByClassName("el-form-item__error").length;
      if (a > 0) {
        console.log("错误");
      } else {
        console.log("正确");
      }
    },
    select (value) {
      console.log(value.toString());
      // return value.toString()
      this.selectedDate = value.toString();
    },
    // 获取当前日期时间段
    getTimeQuantum () {
      for (var item1 in this.bookingForenoonList) {
        if (item1 === this.selectedDate) {
          //item1 表示Json串中的属性，如'name'
          this.$set(
            this.bookingTime,
            "bookingForenoon",
            this.bookingForenoonList[item1]
          ); //动态添加
        }
      }
      for (var item2 in this.bookingNoonList) {
        if (item2 === this.selectedDate) {
          //item2 表示Json串中的属性，如'name'
          this.$set(
            this.bookingTime,
            "bookingNoon",
            this.bookingNoonList[item2]
          ); //动态添加
        }
      }
      for (var item3 in this.bookingAfternoonList) {
        if (item3 === this.selectedDate) {
          //item3 表示Json串中的属性，如'name'
          this.$set(
            this.bookingTime,
            "bookingAfternoon",
            this.bookingAfternoonList[item3]
          ); //动态添加
        }
      }
      for (var item4 in this.bookingNightList) {
        if (item4 === this.selectedDate) {
          //item4 表示Json串中的属性，如'name'
          this.$set(
            this.bookingTime,
            "bookingNight",
            this.bookingNightList[item4]
          ); //动态添加
        }
      }
      for (var item5 in this.bookingAlldayList) {
        if (item5 === this.selectedDate) {
          //item5 表示Json串中的属性，如'name'
          this.$set(
            this.bookingTime,
            "bookingAllday",
            this.bookingAlldayList[item5]
          ); //动态添加
        }
      }
    },
    getTicketLeft () {
      // 获取当前日期开馆时间段的对应票数
      for (var item7 in this.leftTicketForenoonList) {
        if (item7 === this.selectedDate) {
          //item7 表示Json串中的属性，如'name'
          this.$set(
            this.ticketsLeft,
            "bookingForenoon",
            this.leftTicketForenoonList[item7]
          ); //动态添加
        }
      }
      for (var item8 in this.leftTicketNoonList) {
        if (item8 === this.selectedDate) {
          //item8 表示Json串中的属性，如'name'
          this.$set(
            this.ticketsLeft,
            "bookingNoon",
            this.leftTicketNoonList[item8]
          ); //动态添加
        }
      }
      for (var item9 in this.leftTicketAfternoonList) {
        if (item9 === this.selectedDate) {
          //item9 表示Json串中的属性，如'name'
          this.$set(
            this.ticketsLeft,
            "bookingAfternoon",
            this.leftTicketAfternoonList[item9]
          ); //动态添加
        }
      }
      for (var item10 in this.leftTicketNightList) {
        if (item10 === this.selectedDate) {
          //item10 表示Json串中的属性，如'name'
          this.$set(
            this.ticketsLeft,
            "bookingNight",
            this.leftTicketNightList[item10]
          ); //动态添加
        }
      }
      for (var item11 in this.bookingAlldayList) {
        if (item11 === this.selectedDate) {
          //item11 表示Json串中的属性，如'name'
          this.$set(
            this.bookingTime,
            "bookingAllday",
            this.bookingAlldayList[item11]
          ); //动态添加
        }
      }
    },
    chooseTimeQuantum () {
      switch (this.radio1) {
        case "1":
          this.$nextTick(function () {
            this.$set(
              this.calendar1.events,
              this.selectedDate,
              this.ticketsLeft.bookingForenoon
            );
          });
          // console.log(this.calendar1.events[this.selectedDate]);
          this.nowTicketLeft = Number(
            this.ticketsLeft.bookingForenoon.replace(/[^0-9]/gi, "")
          );
          break;
        case "2":
          this.$nextTick(function () {
            this.$set(
              this.calendar1.events,
              this.selectedDate,
              this.ticketsLeft.bookingNoon
            );
          });
          console.log(this.ticketsLeft.bookingNoon);
          this.nowTicketLeft = Number(
            this.ticketsLeft.bookingNoon.replace(/[^0-9]/gi, "")
          );

          break;
        case "3":
          this.$nextTick(function () {
            this.$set(
              this.calendar1.events,
              this.selectedDate,
              this.ticketsLeft.bookingAfternoon
            );
          });
          console.log(this.ticketsLeft.bookingAfternoon);
          this.nowTicketLeft = Number(
            this.ticketsLeft.bookingAfternoon.replace(/[^0-9]/gi, "")
          );

          break;
        case "4":
          this.$nextTick(function () {
            this.$set(
              this.calendar1.events,
              this.selectedDate,
              this.ticketsLeft.bookingNight
            );
          });
          console.log(this.ticketsLeft.bookingNight);
          this.nowTicketLeft = Number(
            this.ticketsLeft.bookingNight.replace(/[^0-9]/gi, "")
          );
          break;
      }
    }
  },
  mounted () {
    this.boolean();
    this.getTicketInfo();
    this.getmuseumInfo();
    this.$nextTick(() => {
      this.inputShow();
    });
  },
  watch: {
    selectedDate () {
      this.getTimeQuantum();
      this.chooseTime = "请选择时间";
      this.getTicketLeft();
      this.calendar1.events = JSON.parse(JSON.stringify(this.initEvents));
      this.radio1 = "1";
    },
    radio1 () {
      this.chooseTimeQuantum();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/bookingInfo.vue